/* tslint:disable */
/* eslint-disable */
/**
 * TOM INTEGRATION API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ContainerHistoryQueryResult } from '../model';
// @ts-ignore
import type { ErrorResponse } from '../model';
/**
 * ContainerHistoryApi - axios parameter creator
 */
export const ContainerHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} containerId 
         * @param {string} [turnoverId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationApiContainerHistoryContainerIdGet: async (containerId: string, turnoverId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'containerId' is not null or undefined
            assertParamExists('integrationApiContainerHistoryContainerIdGet', 'containerId', containerId)
            const localVarPath = `/integration/api/ContainerHistory/{containerId}`
                .replace(`{${"containerId"}}`, encodeURIComponent(String(containerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (turnoverId !== undefined) {
                localVarQueryParameter['turnoverId'] = turnoverId;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json,application/xml,text/xml';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} containerId 
         * @param {number} [tenantId] 
         * @param {string} [turnoverId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationApiInternalContainerHistoryContainerIdGet: async (containerId: number, tenantId?: number, turnoverId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'containerId' is not null or undefined
            assertParamExists('integrationApiInternalContainerHistoryContainerIdGet', 'containerId', containerId)
            const localVarPath = `/integration/api/internal/ContainerHistory/{containerId}`
                .replace(`{${"containerId"}}`, encodeURIComponent(String(containerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (tenantId !== undefined) {
                localVarQueryParameter['tenantId'] = tenantId;
            }

            if (turnoverId !== undefined) {
                localVarQueryParameter['turnoverId'] = turnoverId;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json,application/xml,text/xml';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContainerHistoryApi - functional programming interface
 */
export const ContainerHistoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContainerHistoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} containerId 
         * @param {string} [turnoverId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async integrationApiContainerHistoryContainerIdGet(containerId: string, turnoverId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContainerHistoryQueryResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.integrationApiContainerHistoryContainerIdGet(containerId, turnoverId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainerHistoryApi.integrationApiContainerHistoryContainerIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} containerId 
         * @param {number} [tenantId] 
         * @param {string} [turnoverId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async integrationApiInternalContainerHistoryContainerIdGet(containerId: number, tenantId?: number, turnoverId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContainerHistoryQueryResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.integrationApiInternalContainerHistoryContainerIdGet(containerId, tenantId, turnoverId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContainerHistoryApi.integrationApiInternalContainerHistoryContainerIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ContainerHistoryApi - factory interface
 */
export const ContainerHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContainerHistoryApiFp(configuration)
    return {
        /**
         * 
         * @param {string} containerId 
         * @param {string} [turnoverId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationApiContainerHistoryContainerIdGet(containerId: string, turnoverId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ContainerHistoryQueryResult> {
            return localVarFp.integrationApiContainerHistoryContainerIdGet(containerId, turnoverId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} containerId 
         * @param {number} [tenantId] 
         * @param {string} [turnoverId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationApiInternalContainerHistoryContainerIdGet(containerId: number, tenantId?: number, turnoverId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ContainerHistoryQueryResult> {
            return localVarFp.integrationApiInternalContainerHistoryContainerIdGet(containerId, tenantId, turnoverId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContainerHistoryApi - object-oriented interface
 */
export class ContainerHistoryApi extends BaseAPI {
    /**
     * 
     * @param {string} containerId 
     * @param {string} [turnoverId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public integrationApiContainerHistoryContainerIdGet(containerId: string, turnoverId?: string, options?: RawAxiosRequestConfig) {
        return ContainerHistoryApiFp(this.configuration).integrationApiContainerHistoryContainerIdGet(containerId, turnoverId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} containerId 
     * @param {number} [tenantId] 
     * @param {string} [turnoverId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public integrationApiInternalContainerHistoryContainerIdGet(containerId: number, tenantId?: number, turnoverId?: string, options?: RawAxiosRequestConfig) {
        return ContainerHistoryApiFp(this.configuration).integrationApiInternalContainerHistoryContainerIdGet(containerId, tenantId, turnoverId, options).then((request) => request(this.axios, this.basePath));
    }
}

